<template>
    <div class="privacy-policy-page">
        <div class="container">
            <div class="privacy-content">
                <h1 class="page-title">SYARAT DAN KETENTUAN</h1>
                <p class="last-updated">Terakhir diperbarui: 24 Februari 2026</p>

                <div class="intro-section">
                    <p><strong>PROGRAM AGEN PLN MOBILE BY SI MAMAT</strong></p>
                    <p>
                        Dokumen Syarat dan Ketentuan ini merupakan ketentuan yang mengatur hubungan kerja sama antara pengelola Program Agen PLN Mobile by Si Mamat dengan Agen dalam pelaksanaan pelayanan kelistrikan kepada masyarakat.
                    </p>
                    <p>
                        Dengan melakukan pendaftaran sebagai Agen PLN Mobile by Si Mamat, maka Agen dianggap telah membaca, memahami, dan menyetujui seluruh ketentuan yang tercantum dalam dokumen ini.
                    </p>
                </div>

                <section class="policy-section">
                    <h2>1. Definisi</h2>
                    <ol>
                        <li>Program Agen PLN Mobile by Si Mamat adalah program pelayanan kelistrikan berbasis kemitraan yang bertujuan membantu masyarakat mengakses layanan kelistrikan dengan mudah melalui aplikasi PLN Mobile.</li>
                        <li>Agen adalah individu atau pelaku usaha yang telah terdaftar dan disetujui sebagai mitra pelayanan.</li>
                        <li>Pengelola Program adalah unit kerja PLN yang mengelola Program Agen PLN Mobile by Si Mamat.</li>
                        <li>Pelanggan adalah pengguna layanan listrik dari PT PLN (Persero).</li>
                        <li>PLN Mobile adalah aplikasi resmi layanan pelanggan PLN.</li>
                    </ol>
                </section>

                <section class="policy-section">
                    <h2>2. Ruang Lingkup Layanan</h2>
                    <p>Agen PLN Mobile by Si Mamat dapat memberikan bantuan layanan kepada masyarakat berupa:</p>
                    <ol>
                        <li>Pembelian token listrik</li>
                        <li>Pembayaran tagihan listrik</li>
                        <li>Pengajuan pasang baru listrik</li>
                        <li>Pengajuan perubahan daya</li>
                        <li>Pengaduan gangguan listrik</li>
                        <li>Informasi layanan PLN</li>
                        <li>Aktivasi aplikasi PLN Mobile</li>
                    </ol>
                    <p>Seluruh layanan dilakukan melalui aplikasi resmi PLN.</p>
                </section>

                <section class="policy-section">
                    <h2>3. Persyaratan Menjadi Agen</h2>
                    <p>Calon Agen wajib memenuhi persyaratan sebagai berikut:</p>
                    <ol>
                        <li>Warga Negara Indonesia.</li>
                        <li>Memiliki identitas diri yang sah.</li>
                        <li>Memiliki nomor telepon aktif.</li>
                        <li>Memiliki smartphone berbasis Android.</li>
                        <li>Memiliki akun PLN Mobile.</li>
                        <li>Bersedia mengikuti pembinaan.</li>
                        <li>Bersedia mematuhi aturan program.</li>
                    </ol>
                </section>

                <section class="policy-section">
                    <h2>4. Pendaftaran Agen</h2>
                    <ol>
                        <li>Pendaftaran Agen dilakukan melalui Pengelola Program.</li>
                        <li>Calon Agen wajib mengisi formulir pendaftaran.</li>
                        <li>Pengelola berhak menerima atau menolak pendaftaran.</li>
                        <li>Agen yang disetujui akan mendapatkan identitas Agen.</li>
                    </ol>
                </section>

                <section class="policy-section">
                    <h2>5. Hak Agen</h2>
                    <p>Agen berhak:</p>
                    <ol>
                        <li>Mendapatkan pembinaan dan pelatihan.</li>
                        <li>Mendapatkan informasi layanan terbaru.</li>
                        <li>Mendapatkan insentif sesuai ketentuan.</li>
                        <li>Mendapatkan media promosi Agen.</li>
                        <li>Mendapatkan pendampingan dari Pengelola Program.</li>
                    </ol>
                </section>

                <section class="policy-section">
                    <h2>6. Kewajiban Agen</h2>
                    <p>Agen wajib:</p>
                    <ol>
                        <li>Memberikan pelayanan yang baik.</li>
                        <li>Memberikan informasi yang benar.</li>
                        <li>Menjaga nama baik PLN.</li>
                        <li>Menjaga kerahasiaan data pelanggan.</li>
                        <li>Menggunakan aplikasi secara benar.</li>
                        <li>Melayani pelanggan dengan sopan.</li>
                        <li>Mematuhi aturan PLN.</li>
                    </ol>
                </section>

                <section class="policy-section">
                    <h2>7. Larangan Agen</h2>
                    <p>Agen dilarang:</p>
                    <ol>
                        <li>Mengaku sebagai pegawai PLN.</li>
                        <li>Menggunakan identitas PLN tanpa izin.</li>
                        <li>Melakukan pungutan liar.</li>
                        <li>Melakukan penipuan.</li>
                        <li>Menyalahgunakan data pelanggan.</li>
                        <li>Melakukan transaksi fiktif.</li>
                        <li>Meminta biaya tidak wajar.</li>
                    </ol>
                </section>

                <section class="policy-section">
                    <h2>8. Biaya Jasa Agen</h2>
                    <ol>
                        <li>Agen dapat mengenakan biaya jasa pelayanan.</li>
                        <li>Besaran biaya harus wajar.</li>
                        <li>Biaya harus disampaikan kepada pelanggan.</li>
                        <li>Pengelola dapat mengatur batas biaya jasa.</li>
                    </ol>
                </section>

                <section class="policy-section">
                    <h2>9. Pengawasan</h2>
                    <ol>
                        <li>Pengelola Program berhak melakukan pengawasan.</li>
                        <li>Pengelola berhak melakukan evaluasi.</li>
                        <li>Agen wajib menerima pembinaan.</li>
                    </ol>
                </section>

                <section class="policy-section">
                    <h2>10. Sanksi</h2>
                    <p>Agen yang melanggar ketentuan dapat dikenakan sanksi berupa:</p>
                    <ol>
                        <li>Teguran lisan</li>
                        <li>Teguran tertulis</li>
                        <li>Penonaktifan sementara</li>
                        <li>Pemberhentian sebagai Agen</li>
                    </ol>
                </section>

                <section class="policy-section">
                    <h2>11. Penghentian Keagenan</h2>
                    <p>Status Agen dapat dihentikan apabila:</p>
                    <ol>
                        <li>Agen mengundurkan diri.</li>
                        <li>Agen tidak aktif.</li>
                        <li>Agen melanggar aturan.</li>
                        <li>Program dihentikan.</li>
                    </ol>
                </section>

                <section class="policy-section">
                    <h2>12. Perubahan Ketentuan</h2>
                    <p>Pengelola Program berhak mengubah Syarat dan Ketentuan sewaktu-waktu.<br>Perubahan akan diinformasikan kepada Agen.</p>
                </section>

                <section class="policy-section">
                    <h2>13. Perlindungan Data Pribadi</h2>
                    <ol>
                        <li>Agen wajib menjaga kerahasiaan dan keamanan seluruh data pribadi pelanggan yang diperoleh selama menjalankan kegiatan sebagai Agen.</li>
                        <li>Data pribadi pelanggan yang dimaksud meliputi antara lain:
                            <ul>
                                <li>Nama pelanggan</li>
                                <li>Nomor Identitas (KTP)</li>
                                <li>Nomor telepon</li>
                                <li>Alamat pelanggan</li>
                                <li>Nomor IDPEL atau Nomor Meter</li>
                                <li>Informasi transaksi kelistrikan</li>
                            </ul>
                        </li>
                        <li>Agen hanya diperbolehkan menggunakan data pelanggan untuk keperluan pelayanan kelistrikan melalui aplikasi resmi PLN.</li>
                        <li>Agen dilarang:
                            <ul>
                                <li>Menyebarluaskan data pelanggan kepada pihak lain tanpa izin.</li>
                                <li>Menggunakan data pelanggan untuk kepentingan pribadi.</li>
                                <li>Menjual atau memindahtangankan data pelanggan.</li>
                                <li>Menyimpan data pelanggan tanpa keperluan layanan.</li>
                            </ul>
                        </li>
                        <li>Pengelolaan data pribadi wajib mengikuti ketentuan peraturan perundang-undangan yang berlaku di Indonesia termasuk prinsip perlindungan data pribadi.</li>
                        <li>Agen wajib memastikan bahwa:
                            <ul>
                                <li>Data pelanggan digunakan secara benar.</li>
                                <li>Data pelanggan tidak disalahgunakan.</li>
                                <li>Data pelanggan tidak diakses oleh pihak yang tidak berwenang.</li>
                            </ul>
                        </li>
                        <li>Apabila terjadi kebocoran data atau penyalahgunaan data pelanggan, Agen wajib segera melaporkan kepada Pengelola Program.</li>
                        <li>Pelanggaran terhadap ketentuan perlindungan data pribadi dapat dikenakan sanksi sesuai ketentuan program dan peraturan yang berlaku.</li>
                    </ol>
                </section>

                <section class="policy-section">
                    <h2>14. Penutup</h2>
                    <p>Dengan mendaftar sebagai Agen PLN Mobile by Si Mamat, Agen menyatakan setuju terhadap seluruh ketentuan yang berlaku.</p>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicyPage',
    metaInfo: {
        title: 'Privacy Policy - SI AGEN PLN (SiMaMat)',
        meta: [
            {
                name: 'description',
                content: 'Kebijakan Privasi SI AGEN PLN (SiMaMat) - Pelajari bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi pribadi Anda.'
            }
        ]
    }
}
</script>

<style scoped>
.privacy-policy-page {
    min-height: 100vh;
    background-color: #f8f9fa;
    padding: 2rem 0;
}

.container {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 1rem;
}

.privacy-content {
    background: white;
    border-radius: 8px;
    padding: 2rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    line-height: 1.6;
}

.page-title {
    color: #2c3e50;
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
    text-align: center;
    border-bottom: 3px solid #3498db;
    padding-bottom: 1rem;
}

.last-updated {
    color: #7f8c8d;
    font-style: italic;
    text-align: center;
    margin-bottom: 2rem;
    font-size: 0.9rem;
}

.intro-section {
    margin-bottom: 2rem;
    padding: 1.5rem;
    background-color: #ecf0f1;
    border-radius: 6px;
    border-left: 4px solid #3498db;
}

.intro-section p {
    margin: 0;
    font-size: 1.1rem;
    color: #2c3e50;
}

.policy-section {
    margin-bottom: 2rem;
}

.policy-section h2 {
    color: #2c3e50;
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #ecf0f1;
}

.subsection {
    margin: 1.5rem 0;
}

.subsection h3 {
    color: #34495e;
    font-size: 1.2rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
}

.policy-section p {
    color: #2c3e50;
    margin-bottom: 1rem;
}

.policy-section ul {
    color: #2c3e50;
    padding-left: 1.5rem;
}

.policy-section li {
    margin-bottom: 0.5rem;
}

.contact-info {
    background-color: #f8f9fa;
    padding: 1rem;
    border-radius: 6px;
    border: 1px solid #dee2e6;
}

.contact-info p {
    margin: 0.5rem 0;
}

/* Responsive Design */
@media (max-width: 768px) {
    .container {
        padding: 0 0.5rem;
    }

    .privacy-content {
        padding: 1.5rem;
    }

    .page-title {
        font-size: 2rem;
    }

    .policy-section h2 {
        font-size: 1.3rem;
    }
}

@media (max-width: 480px) {
    .privacy-content {
        padding: 1rem;
    }

    .page-title {
        font-size: 1.8rem;
    }

    .intro-section {
        padding: 1rem;
    }
}
</style>
